export default __webpack_public_path__ + "static/media/app2-9.c0d4ec37.jpg";